import { createAction, props } from '@ngrx/store';
import { AdminOrganizationUser } from 'src/app/admin/models/organization.model';
import { OrganizationUserApiError } from './organization-user.errors';

export const LoadOrganizationUsers = createAction(
  '[Organization User] Load Organization Users',
  props<{ organizationId: number }>(),
);

export const SetOrganizationUsers = createAction(
  '[Organization User] Set Organization Users',
  props<{ users: AdminOrganizationUser[] }>(),
);

export const SetOrganizationUserErrored = createAction(
  '[Organization User] Set Organization User Errored',
  props<{ error: OrganizationUserApiError }>(),
);

export const UpdateOrganizationUser = createAction(
  '[Organization User] Update Organization User',
  props<{
    userId: string;
    user: Partial<AdminOrganizationUser>;
    organizationId: number;
  }>(),
);

export const UpdateOrganizationUserErrored = createAction(
  '[Organization User] Update Organization User Errored',
  props<{ error: OrganizationUserApiError }>(),
);

export const UpdateOrganizationUserSucceeded = createAction(
  '[Organization User] Update Organization User Succeeded',
  props<{ organizationId: number }>(),
);

export const AddOrganizationUser = createAction(
  '[Organization User] Add Organization User',
  props<{ user: Partial<AdminOrganizationUser>; organizationId: number }>(),
);

export const AddOrganizationUserSucceeded = createAction(
  '[Organization User] Add Organization User Succeeded',
  props<{ organizationId: number }>(),
);

export const AddOrganizationUserErrored = createAction(
  '[Organization User] Add Organization User Errored',
  props<{ error: OrganizationUserApiError }>(),
);

export const ShowDisableOrganizationUserConfirm = createAction(
  '[Organization User] Show Disable Organization User Confirm',
  props<{ user: AdminOrganizationUser; organizationId: number }>(),
);
// TODO - retire legacy code STUD-2700
export const RemoveOrganizationUserLegacy = createAction(
  '[Organization User] Remove Organization User (Legacy)',
  props<{ userId: string; organizationId: number }>(),
);

export const RemoveOrganizationUser = createAction(
  '[Organization User] Remove Organization User',
  props<{ userId: string; organizationId: number }>(),
);

export const RemoveOrganizationUserSucceeded = createAction(
  '[Organization User] Remove Organization User Succeeded',
  props<{ organizationId: number }>(),
);

export const RemoveOrganizationUserCancelled = createAction(
  '[Organization User] Remove Organization User Cancelled',
);

export const RemoveOrganizationUserErrored = createAction(
  '[Organization User] Remove Organization User Errored',
  props<{ error: OrganizationUserApiError }>(),
);
